import { client } from './client'
import type { ClaudeApiKeyStatus, ClaudeAuthAvailability, CopilotApiKeyStatus, CopilotAuthAvailability } from '@/types'
import type { SpendingCap } from '@/types/projectSettings'
import type { AzureDevOpsIngestionSetting, SaveAzureDevOpsIngestionSettingRequest } from '@/types/azureDevOpsIngestion'

export const projectSettingsApi = {
  getClaudeApiKey: (projectId: string) =>
    client
      .get<ClaudeApiKeyStatus>(`/projects/${projectId}/settings/claude-api-key`)
      .then(r => r.data),

  saveClaudeApiKey: (projectId: string, apiKey: string) =>
    client.put(`/projects/${projectId}/settings/claude-api-key`, { apiKey }),

  deleteClaudeApiKey: (projectId: string) =>
    client.delete(`/projects/${projectId}/settings/claude-api-key`),

  getClaudeAuthAvailability: (projectId: string) =>
    client
      .get<ClaudeAuthAvailability>(`/projects/${projectId}/claude-auth/availability`)
      .then(r => r.data),

  getCopilotApiKey: (projectId: string) =>
    client
      .get<CopilotApiKeyStatus>(`/projects/${projectId}/settings/copilot-api-key`)
      .then(r => r.data),

  saveCopilotApiKey: (projectId: string, apiKey: string) =>
    client.put(`/projects/${projectId}/settings/copilot-api-key`, { apiKey }),

  deleteCopilotApiKey: (projectId: string) =>
    client.delete(`/projects/${projectId}/settings/copilot-api-key`),

  getCopilotAuthAvailability: (projectId: string) =>
    client
      .get<CopilotAuthAvailability>(`/projects/${projectId}/copilot-auth/availability`)
      .then(r => r.data),

  getClaudeSpendingCap: (projectId: string) =>
    client
      .get<SpendingCap>(`/projects/${projectId}/settings/claude-spending-cap`)
      .then(r => r.data),

  setClaudeSpendingCap: (projectId: string, capUsd: number | null) =>
    client.put(`/projects/${projectId}/settings/claude-spending-cap`, { capUsd }),

  getCopilotSpendingCap: (projectId: string) =>
    client
      .get<SpendingCap>(`/projects/${projectId}/settings/copilot-spending-cap`)
      .then(r => r.data),

  setCopilotSpendingCap: (projectId: string, capUsd: number | null) =>
    client.put(`/projects/${projectId}/settings/copilot-spending-cap`, { capUsd }),

  getAzureDevOpsIngestionSetting: (projectId: string) =>
    client
      .get<AzureDevOpsIngestionSetting | null>(`/projects/${projectId}/settings/azure-devops-ingestion`)
      .then(r => r.data),

  saveAzureDevOpsIngestionSetting: (projectId: string, request: SaveAzureDevOpsIngestionSettingRequest) =>
    client.put(`/projects/${projectId}/settings/azure-devops-ingestion`, request),
}
